import { useLocale } from "next-intl";

import { FavoriteSportsQueryKeys } from "@/tanstackQuery/queries/sportsNew";
import { addFavoriteSport, deleteFavoriteSport } from "@/api/sportsNew";
import { useToggleMutation } from "../hooks";

import { Sport } from "@/types/ApiResponses/Sport";

export const useToggleFavoriteSport = () => {
  const locale = useLocale();
  return useToggleMutation<Sport>({
    queryKey: [FavoriteSportsQueryKeys.All, locale],
    addMutationFn: addFavoriteSport,
    deleteMutationFn: deleteFavoriteSport,
    getSelectionKey: (item) => item.id,
    updateOptions: { preventRefetchOnSettled: true },
  });
};
